import {useObserver} from './useObserver'
import {isomorphicObserver} from 'quickstart/utils'

/**
 * Use a callback ref with ResizeObserver.
 */
export const useResizeObserver = () =>
  useObserver(isomorphicObserver('ResizeObserver'))
